import { map, pick } from 'lodash-es'

const { PDF, IMAGE } = require('../../../menus/constants')

const transformMenu = menu =>
  pick(
    menu,
    'id',
    'format',
    'scrapingInstructions',
    'notScrapeableReason',
    'notScrapeableComment',
  )

const transformMenuChangeDetectionSettings = menuChangeDetectionSettings =>
  pick(
    menuChangeDetectionSettings,
    'changeDetectionMethod',
    'changeDetectionFrequency',
  )

const transformDocumentFiles = documentFiles =>
  map(documentFiles, documentFile =>
    pick(documentFile, 'id', 'isSelected', 'fileCategory', 'fileTitle'),
  )

const transformToMenuScrapingTaskInput = values => {
  const {
    task,
    isDebugModeScraping = false,
    isDefaultScrapingEngine = true,
  } = values

  const menuData = transformMenu(values.menu)

  const menuChangeDetectionSettingsData = transformMenuChangeDetectionSettings(
    values.menu.menuChangeDetectionSettings,
  )

  const menuDocumentFilesData =
    menuData.format === PDF || menuData.format === IMAGE
      ? transformDocumentFiles(values.menuDocumentFiles)
      : []

  return {
    id: task.id,
    menuData,
    menuChangeDetectionSettingsData,
    menuDocumentFilesData,
    isDebugModeScraping,
    isDefaultScrapingEngine,
  }
}

export default transformToMenuScrapingTaskInput
